import React from 'react'
import AppRoutes from './layouts/navigation/AppRoutes'
import { ComponentNavigation } from './layouts/navigation/ComponentNavigation'
import { GridDefaults } from '@moltechDeveloper/molui/molgrid'

GridDefaults.set({
  column: {
    defaults: {
      filter: false,
      sortable: true,
      hideColumnMenu: true
    },
  }
});

const App = () => {
  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  )
}

export default App